import { render, staticRenderFns } from "./SubscriptionFlagDemo.vue?vue&type=template&id=2cedddf2&scoped=true&"
import script from "./SubscriptionFlagDemo.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFlagDemo.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFlagDemo.vue?vue&type=style&index=0&id=2cedddf2&lang=scss&scoped=true&"
import style1 from "./SubscriptionFlagDemo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedddf2",
  null
  
)

export default component.exports